export function abortError() {
    return new DOMException('Upload cancelled', 'AbortError');
}
export function throwIfAborted(signal) {
    if (signal?.aborted)
        throw abortError();
}
export function delay(ms, signal) {
    throwIfAborted(signal);
    return new Promise((resolve, reject) => {
        const onAbort = () => {
            clearTimeout(timer);
            reject(abortError());
        };
        const timer = setTimeout(() => {
            signal?.removeEventListener('abort', onAbort);
            resolve();
        }, ms);
        signal?.addEventListener('abort', onAbort, { once: true });
    });
}
export async function pollUntil(fn, done, { signal, intervalMs = 2000, deadlineMs = 120000 } = {}) {
    throwIfAborted(signal);
    const controller = new AbortController();
    let timedOut = false;
    const onAbort = () => controller.abort();
    const timer = setTimeout(() => {
        timedOut = true;
        controller.abort();
    }, deadlineMs);
    signal?.addEventListener('abort', onAbort, { once: true });
    try {
        for (;;) {
            const value = await new Promise((resolve, reject) => {
                const abort = () => reject(abortError());
                controller.signal.addEventListener('abort', abort, { once: true });
                fn(controller.signal)
                    .then(resolve, reject)
                    .finally(() => controller.signal.removeEventListener('abort', abort));
            });
            if (done(value))
                return value;
            await delay(intervalMs, controller.signal);
        }
    }
    catch (error) {
        if (timedOut)
            throw new Error('Processing timed out');
        throw error;
    }
    finally {
        clearTimeout(timer);
        signal?.removeEventListener('abort', onAbort);
    }
}
//# sourceMappingURL=pollUntil.js.map